require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-deziree-teague.json") })
        }
      }, "path---blog-author-deziree-teague");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-deziree-teague!./.cache/json/blog-author-deziree-teague.json
// module id = 631
// module chunks = 231608221292675